import React, { Component } from "react";
import PropTypes from "prop-types";

import { Card, Form, Button, Input, message, DatePicker } from "antd";
import { connect } from "react-redux";

import moment from "moment";
import "moment/locale/zh-tw";
import locale from "antd/lib/locale/zh_TW";

import RichTextEditor from "./rich-text-editor";
import FilesWall from "./files-wall";

import { ORG_CODE, SYS_CODE } from "../../utils/contrains";
import storageUtils from "../../utils/storageUtils";
import { formateDateDbT_ALL } from "../../utils/dateUtil";
import { req_add_bulletinBoard, req_edit_bulletinBoard } from "../../api";
import "./edit-bulletinboard-modal.css";

const Item = Form.Item;
const { RangePicker } = DatePicker;

class BulletinboardEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    bulletinboard: PropTypes.object,
  };

  state = {
    isUpdate: false,
    isInsert: false,
    item: {
      uid: "",
      organizationKey: ORG_CODE,
      workdomainKey: SYS_CODE,
      msgTitle: "",
      msgContent: "",
      msgAuthorId: "",
      msgAuthorName: "",
      publishDateTime: moment(),
      offLineDateTime: moment().add(7, "days"),
      attacheFileUrl: "",
      msgStatus: "BEEN",
      msgDisplay: "ON",
    },
  };

  constructor(props) {
    super(props);

    this.get_files = React.createRef();
    this.editor = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.init();
  }

  componentDidMount() {}

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const { isUpdate } = this.state;
    //console.log(item);
    if (isUpdate) {
      //   const { uid } = this.props.bulletinBoard;
      //   item.uid = uid;
      item.condition = "BASE";
      //console.log(applycase)
      const result = await req_edit_bulletinBoard(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        // console.log(result)
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    } else {
      const result = await req_add_bulletinBoard(
        item,
        storageUtils.getUser().token
      );
      if (result.status === "success") {
        message.success(result.message);
      } else {
        message.error(result.message);
      }
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init = () => {
    if (this.props.bulletinboard) {
      const item = this.props.bulletinboard;
      this.setState({ item, isUpdate: true });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  onFinish = (values) => {
    //console.log('Success:', values);
    const { userCode, userName } = storageUtils.getUser();
    const { msgTitle } = values;
    //console.log(this.state.item.publishDateTime.toString().indexOf("GMT"));
    const file = this.get_files.current.output_files();
    const attacheFileUrl = file.join();
    const recordDescription = this.editor.current.output_text();
    const bulletinBoard = {
      uid: this.state.item.uid,
      organizationKey: ORG_CODE,
      workdomainKey: SYS_CODE,
      msgTitle: msgTitle,
      msgContent: recordDescription,
      msgAuthorId: userCode,
      msgAuthorName: userName,
      publishDateTime:
        this.state.item.publishDateTime.toString().indexOf("GMT") === -1
          ? this.state.item.publishDateTime
          : formateDateDbT_ALL(this.state.item.publishDateTime),
      offLineDateTime:
        this.state.item.offLineDateTime.toString().indexOf("GMT") === -1
          ? this.state.item.offLineDateTime
          : formateDateDbT_ALL(this.state.item.offLineDateTime),
      attacheFileUrl: attacheFileUrl,
      msgStatus: "BEEN",
      msgDisplay: "ON",
    };
    //console.log(bulletinBoard);
    this.api_modify_item(bulletinBoard);
  };

  handleDateTimeRangeChange = (dates, dateStrings) => {
    const { item } = this.state;
    item.publishDateTime = dateStrings[0];
    item.offLineDateTime = dateStrings[1];
    this.setState({ item });
    //console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
  };

  ///////////////////////////////////////////////////////////

  render() {
    const { isUpdate } = this.state;
    const {
      uid,
      msgTitle,
      msgContent,
      publishDateTime,
      offLineDateTime,
      attacheFileUrl,
    } = this.state.item;
    const fileUrlPath = "/api/UploadFile/AddInsideFile";
    const sourceFile =
      attacheFileUrl === ""
        ? []
        : [
            {
              Uid: uid,
              FileNewName: "已附加檔案",
              FileUrl: attacheFileUrl,
            },
          ];
    return (
      <Card>
        <Form onFinish={this.onFinish} onFinishFailed={this.onFinishFailed}>
          <Item
            label="主旨"
            name="msgTitle"
            initialValue={msgTitle}
            rules={[
              { required: true, whitespace: true, message: "必須填寫主旨" },
            ]}
          >
            <Input placeholder="輸入主旨內容" />
          </Item>
          <Item label="內容" name="msgContent">
            <RichTextEditor
              ref={this.editor}
              edit_input_richtext={msgContent}
            />
          </Item>
          <Item label="附加檔案">
            <FilesWall
              ref={this.get_files}
              data_source={sourceFile}
              api_url={fileUrlPath}
            ></FilesWall>
          </Item>

          <Item label="公告起訖日期">
            <RangePicker
              locale={locale}
              defaultValue={[
                moment(publishDateTime, "YYYY/MM/DD HH:mm:ss"),
                moment(offLineDateTime, "YYYY/MM/DD HH:mm:ss"),
              ]}
              ranges={{
                今天: [moment(), moment()],
                整個月份: [moment().startOf("month"), moment().endOf("month")],
              }}
              showTime
              format="YYYY/MM/DD HH:mm:ss"
              onChange={this.handleDateTimeRangeChange}
            />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" className="wave" block>
              {isUpdate ? "修改" : "送出"}
            </Button>
          </Item>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(BulletinboardEditModal);
